import { render, staticRenderFns } from "./ActorLabelUsage.vue?vue&type=template&id=43fe856c&"
import script from "./ActorLabelUsage.vue?vue&type=script&lang=ts&"
export * from "./ActorLabelUsage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports